import { useTranslation } from 'react-i18next';

import styles from './LanguageDisplay.module.scss';

export function LanguageDisplay(props: {
  language?: { name: string; id: string; shortCode?: string };
  showShortLanguageCode?: boolean;
  customStyles?: {
    languageName?: React.CSSProperties;
    singleValue?: React.CSSProperties;
    icon?: React.CSSProperties;
    option?: React.CSSProperties;
  };
  isMenuOpen?: boolean;
}) {
  const { t } = useTranslation();

  const getDisplayText = () => {
    if (!props?.language?.name) {
      return t('profile.selectLanguage');
    }
    if (props.showShortLanguageCode) {
      return props.language.shortCode;
    }

    return props.language.name;
  };

  return (
    <div className={styles.displayWrapper} style={props.customStyles?.singleValue}>
      <span
        className={styles.languageName}
        style={{
          ...props.customStyles?.languageName,
          ...(props.isMenuOpen ? props.customStyles?.option : {}),
        }}
      >
        {getDisplayText()}
      </span>
    </div>
  );
}
